type TickerIdentity = {
  symbol?: string | null;
  name?: string | null;
  currency?: string | null;
};

const RUPEE_SYMBOL = "\u20B9";

const normalize = (value: unknown) => String(value ?? "").trim().toUpperCase();

export const isUsdInrTicker = (ticker: TickerIdentity) => {
  const symbol = normalize(ticker.symbol);
  const name = normalize(ticker.name);

  return symbol.includes("USDINR") || name.includes("USD/INR") || name.includes("USDINR");
};

const toFiniteNumber = (value: unknown) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
};

const normalizeSignedZero = (value: number) => (Math.abs(value) < 0.0000001 ? 0 : value);
const normalizeCurrency = (value: unknown) => {
  const normalized = String(value ?? "").trim().toUpperCase();
  if (normalized === "INR") return "INR";
  if (normalized === "NONE") return "NONE";
  return "USD";
};

export const resolveTickerCurrency = (ticker: TickerIdentity) => {
  if (isUsdInrTicker(ticker)) {
    return "INR";
  }

  return normalizeCurrency(ticker.currency);
};

export const toDisplayDirectionalChange = (
  ticker: TickerIdentity,
  change: unknown,
  changePercent: unknown
) => {
  const numericChange = toFiniteNumber(change);
  const numericPercent = toFiniteNumber(changePercent);
  const invertDirection = isUsdInrTicker(ticker);

  if (!invertDirection) {
    return {
      change: normalizeSignedZero(numericChange),
      changePercent: normalizeSignedZero(numericPercent),
    };
  }

  // For USD/INR, lower quote means stronger INR; invert sign for UI direction.
  return {
    change: normalizeSignedZero(-numericChange),
    changePercent: normalizeSignedZero(-numericPercent),
  };
};

export const formatTickerPriceLabel = (ticker: TickerIdentity, price: unknown) => {
  const numeric = toFiniteNumber(price);

  if (isUsdInrTicker(ticker)) {
    return `1 USD = ${RUPEE_SYMBOL}${numeric.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const currency = resolveTickerCurrency(ticker);
  if (currency === "INR") {
    return `${RUPEE_SYMBOL}${numeric.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  if (currency === "NONE") {
    return numeric.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return `$${numeric.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatTickerAmountByCurrency = (ticker: TickerIdentity, value: unknown) => {
  const numeric = toFiniteNumber(value);
  const currency = resolveTickerCurrency(ticker);

  if (currency === "INR") {
    return `${RUPEE_SYMBOL}${numeric.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  if (currency === "NONE") {
    return numeric.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return `$${numeric.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};
